import React, { useState, useEffect } from 'react'
import { Layout, Button } from 'antd'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import { MenuOutlined } from '@ant-design/icons'
import css from './Layout.module.css'
import { Sidebar } from './components/Sidebar/Sidebar'
import LoggedUser from './components/LoggedUser/LoggedUser'
import { config } from '@/shared/lib/config'
import { LeftOutlined } from '@ant-design/icons'

const { Header, Content, Sider } = Layout

export function MainLayout() {
  const [collapsed, setCollapsed] = useState<boolean>(false)
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 900)

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 900)
    setCollapsed(window.innerWidth <= 900)
  }

  const toggleSidebar = (value: boolean) => {
    if (isMobile) {
      setCollapsed(value)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const totalHeight = document.documentElement.scrollHeight

  return (
    <Layout className={css.rootLayout}>
      <Header
        style={{
          position: 'fixed',
          width: '100%',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#13304a',
          paddingLeft: isMobile ? '10px' : '50px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {isMobile && (
            <Button
              type='text'
              icon={<MenuOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{ color: 'white' }}
            />
          )}
          <h1 className={css.title}>{config.VITE_APP_NAME}</h1>
        </div>
        <LoggedUser />
      </Header>
      <Layout
        style={{
          paddingTop: '64px',
        }}
      >
        <Sider
          width={200}
          collapsible
          collapsed={collapsed}
          onCollapse={toggleSidebar}
          className={css.layoutSidebar}
          trigger={isMobile ? <LeftOutlined /> : <></>}
          style={
            isMobile
              ? {
                  position: 'absolute',
                  left: collapsed ? '-80px' : '0px',
                  zIndex: 998,
                  minHeight: `${totalHeight}px`,
                }
              : {
                  minHeight: `${totalHeight}px`,
                  left: 0,
                }
          }
        >
          <Sidebar />
        </Sider>
        <Layout style={{ padding: '0' }}>
          <Content>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
      <ScrollRestoration />
    </Layout>
  )
}
